import * as React from 'react';
import { Dialog, DialogContent, DialogTitle, DialogActions, Button } from '@material-ui/core';

interface IProps {
  open: boolean
  children?: any
  onClose(): void
  onConfirm(): void
}

const ConfirmationModal = (props: IProps) => {
  return (
    <Dialog
      open={props.open}
      onClose={props.onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle>Please confirm</DialogTitle>
      <DialogContent>
        {props.children}
      </DialogContent>
      <DialogActions>
        {props.onConfirm &&
          <Button onClick={props.onConfirm} color="primary">
            Yes
          </Button>
        }
        <Button onClick={props.onClose} color="primary">
          No
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default ConfirmationModal



// WEBPACK FOOTER //
// ./src/modules/shared/components/ConfirmationModal.tsx